export default __webpack_public_path__ + "static/media/image44.78d58343.png";